import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import { Product } from '../common/product';
import { ProductResponse } from '../common/product-response';

@Injectable({
  providedIn: 'root'
})
export class AdminProductService {
  private adminApiUrl: string = `${environment.apiUrl}/admin/products`;

  constructor(private httpClient: HttpClient) {}

  getProducts(page: number, size: number): Observable<ProductResponse> {
    const params = new HttpParams()
      .set('page', page.toString())
      .set('size', size.toString());
    return this.httpClient.get<ProductResponse>(this.adminApiUrl, { params });
  }

  getProductById(id: number): Observable<Product> {
    return this.httpClient.get<Product>(`${this.adminApiUrl}/${id}`);
  }

  createProduct(formData: FormData): Observable<Product> {
    return this.httpClient.post<Product>(this.adminApiUrl, formData);
  }

  updateProduct(id: number, formData: FormData): Observable<Product> {
    return this.httpClient.put<Product>(`${this.adminApiUrl}/${id}`, formData);
  }

  deleteProductById(id: number): Observable<any> {
    return this.httpClient.delete(`${this.adminApiUrl}/${id}`);
  }

  reactivateProductById(id: number): Observable<any> {
    return this.httpClient.put(`${this.adminApiUrl}/${id}/reactivate`, {});
  }
}
